import cx from "ui/cx";
import IconExteriorHouse from "ui/icons/IconExteriorHouse";
import type { SvgIconProps } from "ui/icons/SVGIcon";
import styles from "./LoadingHouse.module.scss";

export type LoadingHouseProps = SvgIconProps;

export default function LoadingHouse({ className, ...props }: LoadingHouseProps) {
  return <IconExteriorHouse className={cx(styles.wrapper, className)} {...props} />;
}
